<template>
  <vx-card :title="$t('personal_information')" class="mb-4">

    <h4>{{ $t('avatar') }}</h4>
    <hr class="mt-1 mb-4">

    <div class="mb-3" >
      <file-input :label="$t('upload_photo')" v-model="editMyAccountObj.image" :model="editMyAccountObj.image"></file-input>
    </div>

    <h4>{{ $t('personal_information') }}</h4>
    <hr class="mt-1 mb-4">

    <div class="mb-3">
      <vs-input :label="$t('username')" :placeholder="$t('username')" v-model="editMyAccountObj.username" class="w-full"/>
      <validation-error :model-error="editMyAccountFormErrors.username"></validation-error>
    </div>

    <div class="mb-3">
      <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="editMyAccountObj.name" class="w-full"/>
      <validation-error :model-error="editMyAccountFormErrors.name"></validation-error>
    </div>

    <div class="mb-3">
      <vs-input :label="$t('email')" :placeholder="$t('email')" v-model="editMyAccountObj.email" class="w-full"/>
      <validation-error :model-error="editMyAccountFormErrors.email"></validation-error>
    </div>

    <h4>{{ $t('contact_information') }}</h4>
    <hr class="mt-1 mb-4">

    <div class="mb-3">
      <vs-input :label="$t('landline')" :placeholder="$t('landline')" v-model="editMyAccountObj.landline" class="w-full"/>
      <validation-error :model-error="editMyAccountFormErrors.landline"></validation-error>
    </div>

    <div class="mb-3">
      <vs-input :label="$t('mobile')" :placeholder="$t('mobile')" v-model="editMyAccountObj.mobile" class="w-full"/>
      <validation-error :model-error="editMyAccountFormErrors.mobile"></validation-error>
    </div>

    <template slot="footer">
      <vs-button color="primary" type="filled" @click.prevent="updateMyAccount" v-text="$t('save')"></vs-button>
    </template>
  </vx-card>
</template>

<script>
import {EventBus} from '@/../eventbus'
import MyAccount from '@/models/MyAccount'
import Tagify from '@/components/form-inputs/Tagify'

export default {
  name: 'Admin.MyAccount.PersonalInformation',
  components: {
    Tagify
  },
  data () {
    return {
      accounts: {},
      editMyAccountObj: {
        user_id: '',
        username: '',
        name: '',
        email: '',
        landline: '',
        mobile: ''
      },
      editMyAccountFormErrors: {}
    }
  },
  mounted () {
    this.loadMyAccountList()
  },
  methods: {
    async loadMyAccountList () {
      this.$store.dispatch('setIsMainTableLoading', true)
      const response = await MyAccount.findAll()
      this.accounts = response.data.accounts
      this.editMyAccountObj.user_id = this.accounts.id
      this.editMyAccountObj.name = this.accounts.name
      this.editMyAccountObj.email = this.accounts.email
      this.editMyAccountObj.username = this.accounts.username

      this.editMyAccountObj.landline = this.accounts.landline
      this.editMyAccountObj.mobile = this.accounts.mobile
      this.$store.dispatch('setIsMainTableLoading', false)
    },
    async updateMyAccount () {
      try {
        const response = await MyAccount.update(this.editMyAccountObj)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.loadMyAccountList()

        EventBus.$emit('myAccountUpdated')
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
